$(document).ready(function(){
  $('.hm_primary_btn').click(function(evt){
    evt.preventDefault();
     $('html, body').animate({
          scrollTop: $(".bp_product_headline").offset().top
      }, 500);
  });

  $('.header__shop_button').click(function(evt){
    evt.preventDefault();
     $('html, body').animate({
          scrollTop: $(".bp_product_headline").offset().top
      }, 500);
  });

  $(document).on("click",".homepage-difference-button",function(evt) {
    evt.preventDefault();
     $('html, body').animate({
          scrollTop: $(".bp_product_headline").offset().top
      }, 500);
  });
  
});